<template>
  <div style="">
    <template>
      <el-dialog v-dialogDrag :visible.sync="dialogVisible" :width="width" :before-close="handleClose">
        <div slot="title" class="dialog-title">
          <img :src="src" style="width: 20px;height: 20px;vertical-align: middle;" />
          <span class="title-text" style="color: #333333;margin-left: 10px;font-weight: bold;font-size: 16px;">{{ title }}</span>
          <div class="button-right">
            <span class="title-close" @click="cancel"></span>
          </div>
          <slot></slot>
        </div>

        <span slot="footer" class="dialog-footer">
          <button @click="cancel" style="width: 64px;height: 32px;text-align: center;border-radius: 2px;margin-left: 5px;">取 消</button>
          <button @click="dialogOK" style="background-color: #E71D43;color: #FFF;width: 64px;height: 32px;text-align: center;border-radius: 2px;margin-left: 5px;">确 定</button>
        </span>
      </el-dialog>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: { //状态
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    }
  },
  data: function(){
    return {
      dialogVisibleflag: this.dialogVisible
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    dialogOK() {
      this.$emit('dialogOK')
    },
    handleClose() {
      this.cancel()
    }
  }
}
</script>

<style>
</style>